import { makeStyles } from '@material-ui/core';
export const useCertificateTemplateCMSStyle=makeStyles({
    root:{
        height:"100%"
    },

    header:{

    },
    body:{

    },
    footer:{

    }


})